import { createApp } from 'vue'

import TheIcon from '@shared/components/Container/TheIcon'
import TheScreen from '@shared/components/Container/TheScreen'
import TheSection from '@shared/components/Container/TheSection'

import events$ from '@shared/services/Events'
import Tracking from '@shared/plugins/Tracking'
import i18n, { selectedLanguage, setLanguageGetter } from '@shared/plugins/i18n'

import useI18n from '@shared/hooks/useI18n'
import usePerson from '@shared/hooks/usePerson'
import useSnackbar from '@shared/hooks/useSnackbar'

import clickOutside from '@shared/directives/ClickOutside'
import stickToElement from '@shared/directives/StickToElement'
import tooltip from '@shared/directives/Tooltip'

import { PACKAGE } from '@shared/config/constants'
import { EVENT_OVP } from '@shared/config/events'

// HOOKS
const { getContent } = useI18n()
const { getPersonFullName } = usePerson()
const { addNotification } = useSnackbar()

let isInitialized = false
// eslint-disable-next-line no-undef
const npmVersion = __NPM_VERSION__

async function appInit(appInstance, appName) {
  if (!isInitialized) {
    console.info(
      `%c ⚑ sani%ctas SALES:${appName}`,
      'font-weight:bold;color:#00765A;',
      'font-weight:bold;color:#5BAC26;',
      `v${npmVersion}`
    )

    // @note: this only loads the errors
    await getContent({ app: PACKAGE.ERRORS, language: selectedLanguage.value })

    events$.on(EVENT_OVP.ERROR, message => {
      addNotification({
        key: message.key,
        type: message.type,
        payload: message.payload,
        personId: message.personId || null,
        personFullName: getPersonFullName(message.personId),
      })
    })
    isInitialized = true
  }
  return appInstance
}

async function setup({ appInstance, appName, languageGetter }) {
  appInstance.provide('version$', npmVersion)
  appInstance.provide('appName$', appInstance._component.__name)

  // add global directives
  appInstance.directive('click-outside', clickOutside)
  appInstance.directive('stick-to-element', stickToElement)
  appInstance.directive('tooltip', tooltip)

  // add global components
  appInstance.component('TheIcon', TheIcon)
  appInstance.component('TheScreen', TheScreen)
  appInstance.component('TheSection', TheSection)

  // add global plugins
  setLanguageGetter(languageGetter)
  appInstance.use(i18n)

  if (!isInitialized) {
    appInstance.use(Tracking)
  }

  return await appInit(appInstance, appName)
}

export { createApp, setup }
